"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoleForemanPowerCircuitPhaseHeightFieldJoin = void 0;
const core_shared_1 = require("@ikegps/core-shared");
const field_join_ikecalc_1 = require("./field.join.ikecalc");
const POWER_CIRCUIT_PHASE_HEIGHTS = [
    core_shared_1.IkePoleForemanFieldIds.SPAN_POWER_CIRCUIT_PRIMARY_PHASE_A_HEIGHT,
    core_shared_1.IkePoleForemanFieldIds.SPAN_POWER_CIRCUIT_PRIMARY_PHASE_B_HEIGHT,
    core_shared_1.IkePoleForemanFieldIds.SPAN_POWER_CIRCUIT_PRIMARY_PHASE_C_HEIGHT,
    core_shared_1.IkePoleForemanFieldIds.SPAN_POWER_CIRCUIT_SECONDARY_PHASE_A_HEIGHT,
    core_shared_1.IkePoleForemanFieldIds.SPAN_POWER_CIRCUIT_SECONDARY_PHASE_B_HEIGHT,
    core_shared_1.IkePoleForemanFieldIds.SPAN_POWER_CIRCUIT_SECONDARY_PHASE_C_HEIGHT,
    core_shared_1.IkePoleForemanFieldIds.SPAN_POWER_CIRCUIT_SHIELD_WIRE_HEIGHT,
    core_shared_1.IkePoleForemanFieldIds.SPAN_POWER_CIRCUIT_NEUTRAL_HEIGHT,
];
class PoleForemanPowerCircuitPhaseHeightFieldJoin extends field_join_ikecalc_1.IkeCalcFieldJoin {
    static accepts(field) {
        return POWER_CIRCUIT_PHASE_HEIGHTS.indexOf(field.schema.id) > -1;
    }
    constructor(field) {
        super(field);
        this.type = 'PoleForemanPowerCircuitPhaseHeightJoin';
    }
    /**
     * Check if this field can join with another field by checking if they match framing and conductor types.
     * @param other - The other field to check.
     * @returns True if the field is a power circuit phase height field and matches the other field's framing and conductor types.
     */
    joins(other) {
        const joinableHeight = this.getFieldValue(this.circuit, this.field.schema.id);
        if (joinableHeight != null) {
            return false;
        }
        // Determine which field type this is
        const id = this.field.schema.id;
        const isPrimary = id.startsWith('ipf_spanPowerCircuitPrimary');
        const isSecondary = id.startsWith('ipf_spanPowerCircuitSecondary');
        const isShieldWire = id === core_shared_1.IkePoleForemanFieldIds.SPAN_POWER_CIRCUIT_SHIELD_WIRE_HEIGHT;
        const isNeutral = id === core_shared_1.IkePoleForemanFieldIds.SPAN_POWER_CIRCUIT_NEUTRAL_HEIGHT;
        // Use correct framing/conductor fields for matching
        let framingField = '';
        let conductorField = '';
        if (isPrimary) {
            framingField = core_shared_1.IkePoleForemanFieldIds.SPAN_POWER_CIRCUIT_PRIMARY_FRAMING;
            conductorField = core_shared_1.IkePoleForemanFieldIds.SPAN_POWER_CIRCUIT_PRIMARY_CONDUCTOR;
        }
        else if (isSecondary) {
            framingField = core_shared_1.IkePoleForemanFieldIds.SPAN_POWER_CIRCUIT_SECONDARY_FRAMING;
            conductorField = core_shared_1.IkePoleForemanFieldIds.SPAN_POWER_CIRCUIT_SECONDARY_CONDUCTOR;
        }
        else if (isShieldWire) {
            framingField = core_shared_1.IkePoleForemanFieldIds.SPAN_POWER_CIRCUIT_SHIELD_WIRE_FRAMING;
            conductorField = core_shared_1.IkePoleForemanFieldIds.SPAN_POWER_CIRCUIT_SHIELD_WIRE_CONDUCTOR;
        }
        else if (isNeutral) {
            framingField = core_shared_1.IkePoleForemanFieldIds.SPAN_POWER_CIRCUIT_NEUTRAL_FRAMING;
            conductorField = core_shared_1.IkePoleForemanFieldIds.SPAN_POWER_CIRCUIT_NEUTRAL_CONDUCTOR;
        }
        else {
            return false;
        }
        const framingType = this.getFieldValue(this.circuit, framingField);
        if (framingType && this.isDeadEnd(framingType)) {
            return false;
        }
        if (!other.circuit.hasField(id) || this.getFieldValue(other.circuit, id) != null) {
            return false;
        }
        return (this.spansOpposing(this.span, other.span) &&
            this.fieldsEqual(this.circuit, other.circuit, framingField) &&
            this.fieldsEqual(this.circuit, other.circuit, conductorField) &&
            this.fieldsEqual(this.circuit, other.circuit, core_shared_1.IkePoleForemanFieldIds.SPAN_POWER_CIRCUIT_TYPE));
    }
    // Check if the spans are opposing (i.e., one is a fore span and the other is a back span)
    spansOpposing(spanA, spanB) {
        if (spanA.instanceId === spanB.instanceId ||
            !spanA.hasField(core_shared_1.IkePoleForemanFieldIds.SPAN_TYPE) ||
            !spanB.hasField(core_shared_1.IkePoleForemanFieldIds.SPAN_TYPE)) {
            return false;
        }
        const spanAType = spanA.getField(core_shared_1.IkePoleForemanFieldIds.SPAN_TYPE).value;
        const spanBType = spanB.getField(core_shared_1.IkePoleForemanFieldIds.SPAN_TYPE).value;
        if (!spanAType || !spanBType) {
            return false;
        }
        if ((0, core_shared_1.isIPFSpanType)(spanAType) && (0, core_shared_1.isIPFSpanType)(spanBType) && spanAType !== spanBType) {
            return true;
        }
        return false;
    }
}
exports.PoleForemanPowerCircuitPhaseHeightFieldJoin = PoleForemanPowerCircuitPhaseHeightFieldJoin;
//# sourceMappingURL=field.join.poleforeman.powercircuit.js.map